<template>
      <div class="map-wrapper bg-gray-400 h-96 mb-8">
            <gmaps-map :options="mapOptions" @mounted="ready" ref="map">
                  <gmaps-info-window v-if="openInfoId != null" ref="infowindow" :options="infoWindowOptions" @closed="toggleInfoWindow" />
                  <template v-slot:loading>
                        <div>
                              <span>{{ $t('plase_wait') }}</span>
                        </div>
                  </template>
                  <template v-slot:error="{ error }">
                        <div>
                              <span>{{ $t('error_occured') }}: {{ error }}</span>
                        </div>
                  </template>
                  <gmaps-cluster :items="items" :options="clusterOptions" @click="toggleInfoWindow($event)"/>
            </gmaps-map>
      </div>
</template>

<script>
import { gmapsMap, gmapsCluster, gmapsInfoWindow } from "x5-gmaps";

export default {
      name: "Map",
      components: { gmapsMap, gmapsCluster, gmapsInfoWindow},
      props: {
            itemsPayload: {
                  type: Array
            }
      },
      data(){
            return {
                  mapOptions: {
                        center: {
                              lat: 51.5051847,
                              lng: -2.4839378,
                        },
                        zoom: 7,
                        fullscreenControl: true,
                        mapTypeControl: false,
                        rotateControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        zoomControl: true,
                        styles: [{
                              "featureType": "all",
                              "stylers": [{
                                    "saturation": -100
                              }]
                        }],
                  },
                  clusterOptions: {
                        minZoom: -1,
                        maxZoom: 20,
                        lowPercentage: 5,
                        highPercentage: 20,
                        tileSize: 0.5,
                  },
                  openInfoId: null,
                  infoWindowClosed: true,
                  infoWindowOptions: {
                        position: { lat: -27.46, lng: 153.02 },
                        pixelOffset: {width: 0, height: -45},
                        minWidth: 200,
                        content: '',
                        zIndex: 999999,
                  },
                  items: [],
                  bounds: null,
            }
      },
      methods: {
            ready(map) {
                  if(this.bounds !== undefined && this.bounds != null){
                        map.fitBounds(this.bounds)
                  }
            },
            formatItems(data){
                  if(!data || data === undefined) {
                        return
                  }

                  this.items = []
                  let bounds = new google.maps.LatLngBounds();
                  data.forEach((item,index) => {
                        if(item !== undefined && item.lat && item.long) {
                              const lat = Number(item.lat);
                              const lng = Number(item.long);
                              if(!isNaN(lat) && !isNaN(lng) && bounds != undefined){
                                    bounds.extend(new google.maps.LatLng(lat,lng));
                                    this.items.push({
                                          id: index,
                                          title: item.id,
                                          lat,
                                          lng,
                                          icon: {
                                                url: require('../../../assets/map_pin_blue.png'),
                                                scaledSize: {width: 22, height: 35}
                                          },
                                          optimized: true
                                    })
                              }
                        }
                  })
                  this.bounds = bounds
            },
            setInfoWindowPos(){
                  const item = this.items.find(item => item.id === this.openInfoId)
                  if(item !== undefined) {
                        this.infoWindowOptions.position = { lat: item.lat, lng: item.lng}
                  }
            },
            buildContent(){
                  const item = this.items.find(item => item.id === this.openInfoId)
                  if(item !== undefined) {
                        let output = `<ul>
                                          <li class="text-lg font-bold">
                                                ${item.title}
                                          </li>
                                          <li class="mt-2 text-lg">
                                                Latitude: ${item.lat}
                                          </li>
                                          <li class="text-lg">
                                                Longitude: ${item.lng}
                                          </li>
                                    </ul>
                                    `
                        this.infoWindowOptions.content = output
                  }
            },
            toggleInfoWindow(id){
                  if(id !== null){
                              this.openInfoId = id
                              this.setInfoWindowPos(id)
                              this.buildContent()
                              this.infoWindowClosed = false
                              this.$nextTick(()=> {
                                    this.$refs.infowindow.open();
                              })
                  } else {
                        this.openInfoId = null
                        this.infoWindowClosed = true
                  }
            },
      },
      mounted() {
            this.formatItems(this.itemsPayload)
      },
}
</script>

<style lang="sass">
.gm-style .gm-style-iw-c
      box-shadow: 0 25px 25px rgba(0, 0, 0,.15)
</style>